export class GlobalizationHelper {
  // List matches https://spore.marinsoftware.com/frontend/marin-shared-js/blob/develop/app/shared-js-helpers/supported-currency.json
  public getSupportedCurrencies(): string[] {
    return window.SUPPORTED_CURRENCIES || [];
  }

  public getSupportedLocales(): string[] {
    return window.SUPPORTED_LOCALES || [];
  }

  public getCountryList(): Array<CountryCityObject> {
    return window.COUNTRY_LIST || [];
  }

  public getStatesOfUSA(): Array<CountryCityObject> {
    return window.STATE_LIST || [];
  }
}

export const globalizationHelper = new GlobalizationHelper();

export interface CountryCityObject {
  name: string;
  code: string;
}

export default globalizationHelper;
